export { default } from './PlaceholderPage';
